// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"styles_cardContainer__ImnBX","cardText":"styles_cardText__y7Y1v","cardImage":"styles_cardImage__XUCyK"};